import styled from 'styled-components';

import type { StatusBannerProps } from '@xing-com/banner';
import { StatusBanner } from '@xing-com/banner';

export const Feedback = styled(StatusBanner)<StatusBannerProps>`
  margin-bottom: 0;
`;
